import { Form, SearchableSelectFormField } from "@/components/ui";
import type { AsyncSelectProps } from "@/components/ui/FormFields/AsyncSelectOptions";
import { useForm } from "react-hook-form";

type ReportUserFilterProps = AsyncSelectProps & {
  items: { label: string; value: string }[];
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
};

export function ReportUserFilter({
  items,
  onChange,
  className,
  placeholder = "Assignees",
  ...selectProps
}: ReportUserFilterProps) {
  const form = useForm({ defaultValues: { userId: "" } });
  return (
    <Form {...form}>
      <SearchableSelectFormField
        {...selectProps}
        className={className}
        buttonClassName="h-11"
        register={form.register("userId")}
        items={items}
        itemsKey="value"
        formatItemLabel={(item) => item?.label}
        placeholder={placeholder}
        onChange={(value) => {
          onChange(value);
          form.reset();
        }}
      />
    </Form>
  );
}
